import React from 'react';
import ProgressSpinnerSmall from 'APP_ROOT/components/common/ProgressSpinnerSmall';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { strings } from 'APP_ROOT/localization';
import ConfirmDialog from 'APP_ROOT/components/common/ConfirmDialog';
import Select from 'react-select';
import {SingleDatePicker} from 'react-dates';
import moment from 'moment';
import geofences from 'APP_ROOT/data/geofences';

const OPTIONS_TYPE_VALUES = {
    NEVER: "NEVER",
    END_OF_DAY: "ENDOFDAY" 
}
export class AutoDelete extends React.Component {

    static propTypes = {
        geofenceId: PropTypes.string,
        stage: PropTypes.string.isRequired
    }

    state = {
        confirmRemoveOpen: false,
        focused: false
    }

    selectOptions = [
        { value: OPTIONS_TYPE_VALUES.NEVER, label: strings.geofence_auto_delete_never}, // default
        { value: OPTIONS_TYPE_VALUES.END_OF_DAY, label: strings.geofence_auto_delete_end_of_day} 
    ];

    getSelectOptionsIndexForExpiryDate(expiryDate) {
        if (!expiryDate) {
            return 0; // NEVER
        }
        return 1; // END_OF_DAY
    }

    openConfirmRemoveDialog = e => {
        e && e.preventDefault();
        this.setState({
            confirmRemoveOpen: true
        });
    }

    closeConfirmRemoveDialog = () => this.setState({ confirmRemoveOpen: false });

    remove = () => {
        this.closeConfirmRemoveDialog();
        this.props.removeGeofence();
        this.props.pokeMap();
    }

    onSelectChange = (selectedOption) => {

        const selectedIndex = this.selectOptions.findIndex((option) => {
            return option.value === selectedOption.value;
        });

        if (isNaN(selectedIndex)) {
            console.warn("AutoDelete invalid type selection");
            return;
        }

        switch (this.selectOptions[selectedIndex].value) {

            case OPTIONS_TYPE_VALUES.NEVER:
                this.props.onChange(null); // set undefined
                return;

            case OPTIONS_TYPE_VALUES.END_OF_DAY:
                this.props.onChange(moment().endOf('day').toDate()); // https://momentjs.com/docs/#/manipulating/end-of/
                return;

            default:
                console.warn("AutoDelete's selectOptions and OPTIONS_TYPE_VALUES diverged");
                return;
        }
    }

    onDatePickerChange= (momentDate) => {

        //console.log("momentDate selected: " + momentDate.format());
        momentDate.endOf('day'); // https://momentjs.com/docs/#/manipulating/end-of/
        //console.log("momentDate mutated: " + momentDate.format());

        this.props.onChange(momentDate.toDate());
    }

    // facilitates closing date picker by clicking elsewhere
    onDatePickerFocusChange = ({ focused }) => { // e.g. {"focused":true}
        this.setState({ focused });
    }


    render () {

        const { focused } = this.state;

        const selectOptionIndex = this.getSelectOptionsIndexForExpiryDate(this.props.value);
        const selectedOption = this.selectOptions[selectOptionIndex];

        return (
            <section className="auto-delete">
                <h4 className='label'>{strings.resource_auto_delete}</h4>
                <div className='value'>
                    {this.props.status === "PENDING" ?
                        <div className={"status-overlay"}>
                            <ProgressSpinnerSmall />
                        </div>
                        :
                        null
                    }
                    <Select
                        className="type"
                        //defaultValue={this.selectOptions[0]}
                        value={selectedOption}
                        //isLoading={isLoading}
                        showClearDate={false} // I didn't see this affect change anywhere
                        // clear button removed in _geofenceDetailsPanel.scss
                        escapeClearsValue={false} // prevent clearing current selection
                        isClearable={false} // pertains to completely clearing/emptying the text input field
                        // menuIsOpen={true} // DEV ONLY, also it didn't work
                        isSearchable={false} // disable user input
                        //placeholder={selectedOption} // usually not visible
                        name="autoDeleteType"
                        onChange={this.onSelectChange}
                        options={this.selectOptions}
                        disabled={!this.props.editable}
                    />
                    {selectedOption.value === OPTIONS_TYPE_VALUES.END_OF_DAY &&
                        <SingleDatePicker
                            id="geofence-auto-delete-date"
                            date={moment(this.props.value)}
                            focused={focused}
                            numberOfMonths={1}
                            onDateChange={this.onDatePickerChange}
                            onFocusChange={this.onDatePickerFocusChange}
                        />
                    }
                </div>

                {this.props.editable && this.props.geofenceId &&
                        <React.Fragment>
                            <button
                                className='btn btn-red btn-sm'
                                onClick={this.openConfirmRemoveDialog}
                            >
                                <i className='material-icons'>delete</i>
                                {strings.geofence_remove}
                            </button>
                            <ConfirmDialog
                                isOpen={this.state.confirmRemoveOpen}
                                title={strings.geofence_remove_prompt}
                                onOk={this.remove}
                                onCancel={this.closeConfirmRemoveDialog}
                                onDismiss={this.closeConfirmRemoveDialog}
                            />
                        </React.Fragment>
                }
            </section>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        value: geofences.Selectors.geofenceExpiryDate(state, ownProps.geofenceId),
        status: geofences.Selectors.geofenceExpiryDatePending(state, ownProps.geofenceId) ? 'PENDING' : '',
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onChange: (expiryDate) => dispatch(
            geofences.Actions.setGeofenceExpiryDate(ownProps.stage, ownProps.geofenceId, expiryDate)
        ),
        removeGeofence: (color) => dispatch(
            geofences.Actions.removeGeofence(ownProps.stage, ownProps.geofenceId)
        ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AutoDelete);
